import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import commonApiReducer from "src/appRedux/reducers/commonApiReducer";
import commonDataReducer from "src/appRedux/reducers/commonDataReducer";
import userReducer from "src/appRedux/reducers/userReducer";

export const store = configureStore({
  reducer: {
    commonData: commonDataReducer,
    commonApi: commonApiReducer,
    useInfo: userReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
